import React from "react";
import PropTypes from 'prop-types';

import {Avatar, Box, Typography} from "@mui/material";

const RuleSection = props => {
    const {title, avatarColor, AvatarIcon, children} = props;

    return (
        <Box sx={{mb: 4}}>
            <Box sx={{display: "flex", alignItems: "center"}}>
                <Box sx={{ display: { lg: 'none', xs: 'block' } }}>
                    <Avatar style={{backgroundColor: avatarColor}}>
                        <AvatarIcon/>
                    </Avatar>
                </Box>
                <Typography variant="h4" component="h2" sx={{my:2, ml: {xs: 2, lg: 0}}}>
                    {title}
                </Typography>
            </Box>
            {children}
        </Box>
    )
};

RuleSection.propTypes = {
    title: PropTypes.string.isRequired,
    avatarColor: PropTypes.string.isRequired,
    AvatarIcon: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired
};

export {RuleSection};